import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax

import address from '../src/components/address.vue'
Vue.component('test-address', address)


Vue.use(Vuesax)


// axios
import axios from './axios.js'
Vue.prototype.$http = axios



// Filters
import './filters/filters.js'


// Theme Configurations
import '../themeConfig.js'

// ACL
import acl from './acl/acl'

// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'

// i18n
import i18n from './i18n/i18n'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// TODO::Delete it
// VeeValidate
// import VeeValidate from 'vee-validate'
// Vue.use(VeeValidate)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

import {Grid} from 'ag-grid-enterprise';
import {LicenseManager} from 'ag-grid-enterprise';
LicenseManager.setLicenseKey("CompanyName=33 CLOUDS P.C.,LicensedApplication=COORDI,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-024213,ExpiryDate=5_January_2023_[v2]_MTY3Mjg3NjgwMDAwMA==8462d2edfa827c2271664faf8515023c");

import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter,
    {
      name: 'integer_format',
      symbol : '',
      thousandsSeparator: '.',
      fractionCount: 0,
      fractionSeparator: ',',
      symbolPosition: 'front',
      symbolSpacing: false,
      avoidEmptyDecimals: undefined,
    })

// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  acl,
  render: h => h(App)
}).$mount('#app')
